import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 right-0 bottom-0 left-0 bg-gray-200" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-6 h-20 w-full px-8 md:top-14"
}
const _hoisted_3 = { class: "fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    show: !_ctx.loaded,
    enter: "transition-opacity duration-75",
    "enter-from": "opacity-0",
    "enter-to": "opacity-100",
    leave: "transition-opacity duration-150",
    "leave-from": "opacity-100",
    "leave-to": "opacity-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.companyLogoHtml)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_CompanyLogo, {
                "logo-html": _ctx.companyLogoHtml,
                class: "object-center"
              }, null, 8, ["logo-html"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AppLoader, {
            size: "xxl",
            class: "md:h-12 md:w-12"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}